import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Navigate, Route, Routes, useNavigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import App from './App.jsx'
import Landing from './Landing.jsx'
import Login from './Login.jsx'
import SettingsPage from './SettingsPage.jsx'
import ErrorBoundary from './components/ErrorBoundary.jsx'
import { AuthProvider, useAuth } from './contexts/AuthContext.jsx'
import Apresentacao from './Apresentacao.jsx'
import './index.css'

function LandingPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  return (
    <Landing onLogin={() => navigate(user ? '/dashboard' : '/login')} isLoggedIn={!!user} />
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<App />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/apresentacao" element={<Apresentacao />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
)
